module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.3fdaef65.svg";